export default {
    analysisTools: 'Outras ferramentas',
    collapse: 'Recolher',
    expand: 'Expandir',
    display: 'Display',
    customAnalysis: 'Análise personalizada',
    automaticInsights: 'Insights automáticos',
    insightsAndAlerts: 'Insights e alertas',
    dashboards: 'Dashboards',
    settings: 'Configurações',
}
